export default "__VITE_ASSET__DTMn2VTX__"